import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	partners: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	trainingCertification: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	documentation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	developerResources: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	enterpriseServices: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seeAllResources: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'twg-microsite.footer.learn.heading',
		defaultMessage: 'Learn',
		description: 'Heading for the Learn column in the footer',
	},
	partners: {
		id: 'twg-microsite.footer.learn.partners',
		defaultMessage: 'Partners',
		description: 'Footer link in the Learn column',
	},
	trainingCertification: {
		id: 'twg-microsite.footer.learn.trainingCertification',
		defaultMessage: 'Training & certification',
		description: 'Footer link in the Learn column',
	},
	documentation: {
		id: 'twg-microsite.footer.learn.documentation',
		defaultMessage: 'Documentation',
		description: 'Footer link in the Learn column',
	},
	developerResources: {
		id: 'twg-microsite.footer.learn.developerResources',
		defaultMessage: 'Developer resources',
		description: 'Footer link in the Learn column',
	},
	enterpriseServices: {
		id: 'twg-microsite.footer.learn.enterpriseServices',
		defaultMessage: 'Enterprise services',
		description: 'Footer link in the Learn column',
	},
	seeAllResources: {
		id: 'twg-microsite.footer.learn.seeAllResources',
		defaultMessage: 'See all resources →',
		description:
			'Call-to-action link at the bottom of the Learn column linking to the full resources list',
	},
});
